import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    FETCH_EVENTS,
    fetchEventsSuccessful
} from '../actions'



function * fetchEvents (payload){
    try{
       const response=  yield call(DCore.get, `/events/invitees/${payload.data}`)
        yield put (fetchEventsSuccessful(response.data))
    }catch(e){
        console.log("some thing went wrong", e)
    }
}



export function * eventsSaga(){
    yield takeLatest(FETCH_EVENTS,fetchEvents)
}